var React = require('react');

function EmojiSmile (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_375","data-name":"Group 375","transform":"translate(-172.189 -616.354)"},React.createElement("path",{"id":"Path_601","data-name":"Path 601","d":"M203.718,679.328a31.529,31.529,0,1,1,22.23-9.256A30.315,30.315,0,0,1,203.718,679.328Zm-18.173-13.356a25.457,25.457,0,1,0-7.608-18.173A24.8,24.8,0,0,0,185.545,665.971Zm-1.692-18.512h5.918a14.511,14.511,0,0,0,3.972,10.4,13.559,13.559,0,0,0,10.144,3.972,13.25,13.25,0,0,0,9.973-3.93q3.8-3.931,3.8-10.441H223.5q0,9.048-5.411,14.625T203.8,667.663q-8.96,0-14.453-5.579T183.854,647.459Zm4.565-14.791H197.8v9.381h-9.383Zm21.216,0h9.383v9.381h-9.383Z"})));
}

EmojiSmile.defaultProps = {"width":"62.972","height":"62.974","viewBox":"0 0 62.972 62.974"};

module.exports = EmojiSmile;

EmojiSmile.default = EmojiSmile;
